import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Card)`
  /* .Table {
    border: none !important;
  }
  table {
    border: none !important;
    border-collapse: separate !important;

    thead {
      border: none !important;

      tr {
        background-color: transparent !important;
        border: none !important;

        th {
          background-color: ${(p) => p.theme.palette.grey[200]};
        }
        th:first-child {
          border-radius: ${(p) => p.theme.spacing(1, 0, 0, 1)};
        }
        th:last-child {
          border-radius: ${(p) => p.theme.spacing(0, 1, 1, 0)};
        }
      }
    }
    tbody {
      tr {
        background-color: transparent !important;
        td {
          background-color: ${(p) => p.theme.palette.grey[100]};
          min-height: ${(p) => p.theme.spacing(3)} !important;
        }
        td:first-child {
          border-radius: ${(p) => p.theme.spacing(1, 0, 0, 1)};
        }
        td:last-child {
          border-radius: ${(p) => p.theme.spacing(0, 1, 1, 0)};
        }
      }
    }
  } */
`;

export const StyledSearchCard = styled(Card)`
  padding: 0 0;
  display: flex;
  flex-direction: column;

  & > div:not(:last-child, :first-child) {
    border-bottom: 1px dashed ${(p) => p.theme.palette.grey['400']};
  }
`;
